module.exports = __webpack_public_path__ + "img/02.6a5cf496.png";